import _ from 'underscore';
import { convertFromLocationTarget } from './location-targets';

export const unitValueMap = {
  None: {
    value: 1,
    unit: '',
  },
  Thousand: {
    value: 1000,
    unit: 'K',
  },
  Million: {
    value: 1000000,
    unit: 'M',
  },
  Billion: {
    value: 1000000000,
    unit: 'B',
  },
};

export const getEstimationAudienceValueV2 = (estimationDataV2) => {
  const estimationAudienceUnit = _.get(estimationDataV2, ['EstAudienceSize', 'Unit']) || 'None';
  const estimationAudienceValue = unitValueMap[estimationAudienceUnit].value * (_.get(estimationDataV2, ['EstAudienceSize', 'Value']) || 0);
  return estimationAudienceValue;
};

export const getFormattedTargetsPayload = (data, isV2) => {
  const {
    targets = {},
    audiencesSignal = {},
  } = data || {};

  const {
    ageRanges = [],
    genderTypes = [],
    audienceListInFlatTree = [],
    interests = [],
  } = audiencesSignal;

  if (isV2) {
    return ({
      Age: {
        Includes: ageRanges,
        Excludes: [],
      },
      Gender: {
        Includes: genderTypes,
        Excludes: [],
      },
      Audience: {
        Includes: _.map(_.map(interests, interest => _.find(audienceListInFlatTree, aud => _.get(aud, 'value', '') === interest)), o => _.get(o, 'id')),
        Excludes: [],
      },
      Location: {
        Includes: _.compact(_.get(targets, 'positiveLocationTargets', []).map(locationTarget => _.get(locationTarget, ['location', 'Id']))),
        Excludes: _.compact(_.get(targets, 'negativeLocationTargets', []).map(locationTarget => _.get(locationTarget, ['location', 'Id']))),
      },
      // comment out the following fields as pmax campaign type is not supported in the API
      // CampaignBiddingStrategy: null,
      // AutoTargeting: true,
      // CampaignSubType: null,
    });
  }

  return _.map(
    _.get(targets, 'positiveLocationTargets', []),
    (locationTarget) => {
      const formattedTarget = convertFromLocationTarget(locationTarget);
      formattedTarget.Id = String(formattedTarget.Id);

      return formattedTarget;
    }
  );
};
